import { IModalService } from '../modal';

interface IModalOptions {
    key: string;
    overlayEl: Element;
}

class ModalService extends IModalService {
    private _modals: IModalOptions[] = [];

    public addModal(key: string, overlayEl: Element, hidePreviousModal: boolean = true): void {
        const lastModal = this._modals[this._modals.length - 1];
        if (lastModal && hidePreviousModal) {
            // hide previous modal when new one appears
            (lastModal.overlayEl as HTMLElement).style.display = 'none';
        }
        // add new modal to array of modals
        this._modals.push({key: key, overlayEl: overlayEl});
    }

    public removeModal(key: string): void {
        // remove closed modal from array of modals
        this._modals = this._modals.filter(el => el.key !== key);
        const lastModal = this._modals[this._modals.length - 1];
        if (lastModal) {
            // show last modal in array on any modal closing
            (lastModal.overlayEl as HTMLElement).style.display = 'block';
        }
    }

    public generateModalKey(): string {
        return (new Date()).getTime().toString(10);
    }

    public get modals(): IModalOptions[] {
        return this._modals;
    }
}

export { ModalService };
